<script setup lang="ts">
import { computed } from 'vue'
import { type RouteLocationRaw, useRouter } from 'vue-router'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<{
    to: RouteLocationRaw
    external: boolean
  }>(),
  { external: false },
)

const router = useRouter()

const target = computed(() => (props.external ? '_blank' : '_self'))
const href = computed(() => {
  const targetLocation = router.resolve(props.to)

  if (document.location.pathname === '/') {
    return targetLocation.href
  }

  return '/' + targetLocation.href // Fix Link for legacy location
})
</script>

<template>
  <a v-bind="$attrs" :href="href" :target="target">
    <slot />
  </a>
</template>
